import { useState } from "react";
import { api, formatApiErrorDetail } from "../lib/apiClient";
import { EVENT } from "../config";
import { Lock } from "lucide-react";

export const PasswordGate = ({ onUnlock }) => {
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await api.post("/site/unlock", { password: password.trim() });
      localStorage.setItem("site_unlocked", "true");
      onUnlock();
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail, "Something went wrong. Please try again."));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="flex min-h-screen items-center justify-center bg-[#F2EDE3] px-6"
      data-testid="password-gate"
    >
      <div className="w-full max-w-md border border-[#DCD3C0] bg-[#FAF7F0]/90 p-10 text-center backdrop-blur-md">
        <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full border border-[#DCD3C0]">
          <Lock className="h-5 w-5 text-[#7A6A5E]" strokeWidth={1.5} />
        </div>
        <h1 className="mt-8" data-testid="gate-logo">
          <img
            src={EVENT.logo}
            alt={`${EVENT.name} ${EVENT.age}`}
            className="mx-auto h-28 w-28"
          />
        </h1>
        <p className="mt-3 font-light text-[#7A7264]">
          This invitation is private. Enter the password to continue.
        </p>

        <form onSubmit={submit} className="mt-8 space-y-4">
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Password"
            autoFocus
            data-testid="site-password-input"
            className="h-12 w-full border border-[#DCD3C0] bg-[#F2EDE3] px-4 text-[#3F3A32] placeholder:text-[#AFA58F] outline-none focus:border-[#7A6A5E]"
          />
          {error && (
            <p className="text-sm text-red-400" data-testid="site-password-error">
              {error}
            </p>
          )}
          <button
            type="submit"
            disabled={loading}
            data-testid="site-password-submit"
            className="h-12 w-full bg-[#3F3A32] text-sm font-medium uppercase tracking-[0.15em] text-[#F5F1E8] transition-colors hover:bg-[#57503F] disabled:opacity-50"
          >
            {loading ? "Checking…" : "Unlock invitation"}
          </button>
        </form>
      </div>
    </div>
  );
};
